import { organisatieRoutes } from './ORGANISATIES/routes'
import { sponsorRoutes } from './SPONSORS/routes'
import { reviewRoutes } from './REVIEW/routes'
var r = []

r.push.apply(r, organisatieRoutes)
r.push.apply(r, sponsorRoutes)
r.push.apply(r, reviewRoutes)
export const variableRoutes = r;